import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import Pagination from "react-js-pagination";
import {apiService} from '../../common/apiCallService';
import Loading from '../Loading.js';
import {baseUrl} from '../../common/config.js';
import Menu from '../Menu.js'
import { Redirect } from 'react-router';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import RaisedButton from 'material-ui/RaisedButton';
import Paper from 'material-ui/Paper';
import IconButton from 'material-ui/IconButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import validator from 'validator';
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';
import { createVirtualPageLoad, closeVirtualPage } from '../../common/commonService'

class BusinessList extends Component {

  constructor(props) {
    super(props)
    this.state = {
      businessList: [],
      mainBussList: [],
      loginRedirect: false,
      loading: false,
      title: 'Business List',
      activePage: 1,
      max: 10,
      totalCount: 0,
      offset: 0,
      sortBy: 'asc',
      currColumn: 'business_name',
      showForm: false,
      modalTitle: '',
      businessType: '',
      mainBusiness: '',
      business_name: '',
      access: JSON.parse(localStorage.getItem('userRole')),
      _id: '',
      businessType_error: '',
      business_name_error: '',
      mainBusiness_error: '',
      openerrDialog:false,
      msg:''
    }
    this.sorting = this.sorting.bind(this)
    this.callApi = this.callApi.bind(this)
    this.openForm = this.openForm.bind(this)
    this.onPaginate = this.onPaginate.bind(this)
    this.getMainBusiness = this.getMainBusiness.bind(this)
    this.closeForm = this.closeForm.bind(this)
    this.callApi();
    this.getMainBusiness()
  }

  componentWillMount() {
    if(this.state.access.indexOf('SYS_ADMIN') === -1)
      this.setState({loginRedirect: true})
  }

  componentDidMount() {
    createVirtualPageLoad("/businessList")
  }

  componentWillUnmount() {
    closeVirtualPage()
  }

  sorting(column) {
      this.setState({loading: true})
      if(column == this.state.currColumn) {
        if(this.state.sortBy == 'asc') this.state.sortBy = 'desc'
        else this.state.sortBy = 'asc'
      } else {
        this.state.sortBy = 'asc'
      }
      this.state.currColumn = column
      this.callApi();
  }

  callApi() {
    this.setState({loading: true})
      apiService(baseUrl + '/business/getAllBusinessList', {
        "max": this.state.max,
        "offset": this.state.offset,
        "sortBy": this.state.sortBy,
        "column": this.state.currColumn
      }, (data) => {
          this.setState({businessList: data.list})
          this.setState({totalCount: data.count})
          this.setState({loading: false})
      }, (data) => {
          this.setState({loading: false})
          if(data.status == 403) {
            localStorage.setItem("pathName", this.props.location.pathname)
            this.setState({loginRedirect: true})
          }
      })
  }

  onPaginate(pageNumber) {
      this.setState({loading: true})
      this.state.activePage=pageNumber
      this.state.offset = (pageNumber - 1) * this.state.max
      this.callApi();
  }

  openForm() {
    this.setState({showForm: true})
    this.setState({modalTitle: 'New Business'})
  }

  getBussDtls = (id) => {
    this.setState({loading: true})
      apiService(baseUrl + '/business/getBusinessDtls', {
        "_id": id
      }, (data) => {
        this.setState({loading: false})
        this.setState({business_name: data.business_name})
        if(data.parent_business)
          this.setState({mainBusiness: data.parent_business})
        this.setState({businessType: data.type[0]})
        this.setState({_id: data._id})
        this.openForm()
      }, (data) => {
          this.setState({loading: false})
          if(data.status == 403) {
            localStorage.setItem("pathName", this.props.location.pathname)
            this.setState({loginRedirect: true})
          }
      })
  }

  getMainBusiness() {
    this.setState({loading: true})
      apiService(baseUrl + '/business/getBusinessList', {}, (data) => {
        if(data.length > 0)
          this.setState({mainBussList: data})
      }, (data) => {
          this.setState({loading: false})
          if(data.status == 403) {
            localStorage.setItem("pathName", this.props.location.pathname)
            this.setState({loginRedirect: true})
          }
      })
  }

  updateBusiness = () => {
    this.setState({loading: true})
      apiService(baseUrl + '/business/updateBusiness', {
        "_id": this.state._id,
        "business_name": this.state.business_name,
        "type": this.state.businessType,
        "parent_business": this.state.mainBusiness
      }, (data) => {
        this.setState({loading: false})
        this.setState({_id: ''})
        this.closeForm()
        this.callApi();
        this.getMainBusiness()
      }, (data) => {
        // this.setState({_id: ''})
        // this.closeForm()
        this.setState({loading: false})
        if(data.status == 406) {
          this.setState({
            msg: data.responseJSON.errorMsg,
            openerrDialog: true
          })
        }
        if(data.status == 403) {
          localStorage.setItem("pathName", this.props.location.pathname)
          this.setState({loginRedirect: true})
        }
      })
  }

  saveBusiness = () => {
    this.setState({loading: true})
      apiService(baseUrl + '/business/saveBusiness', {
        "business_name": this.state.business_name,
        "type": this.state.businessType,
        "parent_business": this.state.mainBusiness
      }, (data) => {
         this.setState({loading: false})
         this.callApi();
         this.closeForm()
         this.getMainBusiness()
      }, (data) => {
          this.setState({loading: false})
          if(data.status == 406) {
            this.setState({
              msg: data.responseJSON.errorMsg,
              openerrDialog: true
            })
          }
          if(data.status == 403) {
            localStorage.setItem("pathName", this.props.location.pathname)
            this.setState({loginRedirect: true})
          }
      })
  }

  validate = () => {
    this.setState({businessType_error: ''})
    this.setState({mainBusiness_error: ''})
    this.setState({business_name_error: ''})

    if(validator.isEmpty(this.state.businessType)) return this.setState({businessType_error: 'Select Business Type'})
    if(this.state.businessType === 'Sub_Business')
      if(validator.isEmpty(this.state.mainBusiness)) return this.setState({mainBusiness_error: 'Select Main Business'})
    if(validator.isEmpty(this.state.business_name)) return this.setState({business_name_error: 'Enter Business Name'})

    if(this.state._id) this.updateBusiness()
    else this.saveBusiness()
  }

  closeForm() {
    this.setState({showForm: false});
    this.setState({business_name: ''})
    this.setState({businessType: ''})
    this.setState({mainBusiness: ''})
    this.setState({_id: ''})
  };

  deleteBuss = (id) => {
    this.setState({loading: true})
      apiService(baseUrl + '/business/deleteBusiness', {_id: id}, (data) => {
        this.setState({loading: false})
        this.callApi();
        this.getMainBusiness()
        alert(data.msg)
      }, (data) => {
          this.setState({loading: false})
          if(data.status == 403) {
            localStorage.setItem("pathName", this.props.location.pathname)
            this.setState({loginRedirect: true})
          }
      })
  }

   handleClose = () => {
     this.setState({openerrDialog: false});
   };

  render() {
    this.props.setHeaderTitle(this.state.title)
    const erractions = [
        <FlatButton
           label="Ok"
           primary={true}
           keyboardFocused={true}
           onClick={this.handleClose}

         />,
       ];

    const actions = [
      <FlatButton
        label="CANCEL"
        data-e2e="CANCEL"
        primary={true}
        onClick={this.closeForm}
      />,
      <FlatButton
        label="SUBMIT"
        data-e2e="SUBMIT"
        primary={true}
        onClick={this.validate}
      />,
    ];

    const style = {

  position: 'absolute',
  bottom: 20,
  right: 20
};
    return (
      <div>
        {this.state.loading
          ? <Loading/>
          : null}
      {this.state.loginRedirect && (
     <Redirect to={'/'}/>
   )}
      <Menu title={this.state.title}/>
      <div className="container">
        <br/>

            <RaisedButton label="ADD NEW" data-e2e="Add-New" onClick={this.openForm} primary={true} style={{float: 'right'}}/>

      {
        this.state.totalCount == 0 ?
        <div>
          <h5><center>No Data Available For Given Search Date</center></h5>
        </div>
        :
        <div><br/><br/>
          <Paper zDepth={1} rounded={false} className="resp-paper">
          <Dialog
            actions={erractions}
            modal={false}
            open={this.state.openerrDialog}
            onRequestClose={this.handleClose}
          >
           {this.state.msg}
          </Dialog>

          <table className="resp-table resp-table-background">
            <thead className="resp-table-head">
              <tr className="resp-table-tr">
                      <th  onTouchTap={() => this.sorting('business_name')} className="resp-table-th">Name&nbsp;
                          <i className="fa fa-sort " data-e2e="Name" ></i>
                      </th>
                      <th  onTouchTap={() =>  this.sorting('type')} className="resp-table-th">Type&nbsp;
                          <i className="fa fa-sort " data-e2e="Type" ></i>
                      </th>
                      <th  className="resp-table-th">Business
                      </th>
                      <th  onTouchTap={() => this.sorting( 'status')} className="resp-table-th">Status&nbsp;
                        <i className="fa fa-sort " data-e2e="status"></i>
                      </th>
                      <th  className="resp-table-th">
                      </th>
                      <th  className="resp-table-th">
                      </th>
                  </tr>
              </thead>
              <tbody className="resp-table-body">

                    {this.state.businessList.map((item, key) => {
                        return (
                          <tr key={key} className="resp-table-tr">

                                <td className="BusinessList resp-table-td" >{item.business_name}</td>
                                <td className="BusinessList resp-table-td">{item.type}</td>
                                <td className="BusinessList resp-table-td">{
                                  item.parent_business && item.parent_business.business_name
                                  ? item.parent_business.business_name
                                  : '---'}</td>
                                <td className="BusinessList resp-table-td">{item.status}</td>
                                <td className="BusinessList resp-table-td" style={{padding: '0px'}}>
                                  <IconButton iconClassName="fa fa-edit" onTouchTap={() => this.getBussDtls(item._id)}/>
                                </td>
                                <td className="BusinessList resp-table-td" style={{padding: '0px'}}>
                                  <IconButton iconClassName="fa fa-trash" onTouchTap={() => this.deleteBuss(item._id)}/>
                                </td>
                            </tr>
                        )
                    })}

              </tbody>
          </table>
        </Paper>
          <div >
            {this.state.totalCount > 10
            ? <div style={{textAlign: "center"}}>
              <Pagination prevPageText='Prev'
                nextPageText='Next'
                firstPageText='First'
                lastPageText='Last'
                activePage={this.state.activePage}
                itemsCountPerPage={this.state.max}
                totalItemsCount={this.state.totalCount}
                pageRangeDisplayed={5}
                onChange={this.onPaginate}/>
            </div>
            : null}
        </div>
        </div>
        }
      </div>
      <Dialog title={this.state.modalTitle} actions={actions} modal={true} open={this.state.showForm} onRequestClose={this.closeForm} autoScrollBodyContent={true}>
      <center>
      <SelectField
      floatingLabelText="Select Type"
      data-e2e="Select-Type"
      value={this.state.businessType}
      style={{textAlign: 'left'}}
      errorText = {this.state.businessType_error}
      onChange = {(event, index, value) => this.setState({businessType: value})}
      >
        <MenuItem value='Business' primaryText='Business' data-e2e="Business" />
        <MenuItem value='Sub_Business' primaryText='Sub-Business' data-e2e="Sub_Business" />
      </SelectField><br/>
      {
        this.state.businessType == 'Sub_Business'
        ? <SelectField
        floatingLabelText="Select Business"
        value={this.state.mainBusiness}
        style={{textAlign: 'left'}}
        errorText = {this.state.mainBusiness_error}
        onChange = {(event, index, value) => this.setState({mainBusiness: value})}
        >
        {
          this.state.mainBussList.map((item, key) => {
            return (
              <MenuItem value={item._id} primaryText={item.business_name} />
            )
          })
        }
        </SelectField>
        :null
      }

      <br/>
      <TextField
       hintText="Enter Business Name"
       data-e2e="Business-Name"
       floatingLabelText="Business Name" ref="business_name"
       value = {this.state.business_name}
       errorText = {this.state.business_name_error}
       onChange = {(event,newValue) => this.setState({business_name: newValue})}
       />

      </center>
      </Dialog>
      </div>
    )
  }

}

const mapDispatchToProps = dispatch => {
  return {
    setHeaderTitle : ( newTitle ) => dispatch(actions.setHeaderTitle( newTitle ))
  }
};

export default connect(null, mapDispatchToProps)(BusinessList);



/** WEBPACK FOOTER **
 ** ./src/components/Business/BusinessList.js
 **/